import { render, staticRenderFns } from "./ArticleInfoNormalTemplate.vue?vue&type=template&id=4165e58c&"
import script from "./ArticleInfoNormalTemplate.vue?vue&type=script&lang=ts&"
export * from "./ArticleInfoNormalTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports